import qs from "query-string";
import { useState, useCallback, useEffect } from "react";

import useService from "../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";

export function useCaseSearch() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [limit, setLimit] = useState(null);
  const [offset, setOffset] = useState(null);

  const enumRepo = useService("repositories/enum-repository");

  const fetchAllCases = useCallback(
    async (append = false, isNewSearch = false, currentSearch = search) => {
      setLoading(true);
      try {
        const params = {};
        if (isNewSearch && currentSearch?.trim()) {
          params.search = currentSearch.trim();
        }
        if (!isNewSearch && limit) {
          params.limit = limit;
        }
        if (!isNewSearch && offset) {
          params.offset = offset;
        }

        const qsStr = Object.keys(params).length ? `?${qs.stringify(params)}` : "";
        const urlPath = `core/dynamic-options/cases${qsStr}`;

        const response = await enumRepo.query({ urlPath });

        const nextPageURL = await enumRepo.getNextPage();
        if (nextPageURL) {
          setShowMore(true);
          const url = new URL(nextPageURL);
          setLimit(parseInt(url.searchParams.get("limit")) || params.limit || null);
          setOffset(parseInt(url.searchParams.get("offset")) || params.offset || null);
        } else {
          setShowMore(false);
        }

        const mapped = response?.map((i) => ({ id: i.key, label: i.value })) || [];
        setData((prev) => (append ? [...prev, ...mapped] : mapped));
      } catch (err) {
        console.error(err);
        ApiRequestErrorHandler(err);
      } finally {
        setLoading(false);
      }
    },
    [search, limit, offset, enumRepo]
  );

  const fetchCase = async (caseId) => {
    try {
      if (!caseId) {
        throw new Error("Case ID is undefined");
      }
      let localMatch = data.find((item) => item?.id === Number(caseId));
      if (!localMatch) {
        const params = { search: caseId };
        const apiResponse = await enumRepo.query({
          urlPath: `core/dynamic-options/cases?${qs.stringify(params)}`,
        });
        const mapped = apiResponse?.map((item) => ({ id: item.key, label: item.value })) || [];
        localMatch = mapped[0] ?? null;
      }
      return localMatch;
    } catch (error) {
      console.error(error);
      ApiRequestErrorHandler(error);
    }
  };

  useEffect(() => {
    fetchAllCases(false, true);
  }, [search, fetchAllCases]);

  return {
    data,
    search,
    setSearch,
    loading,
    showMore,
    handleShowMore: () => fetchAllCases(true, false),
    fetchCase,
  };
}
